// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3ADWC","buttons":"Footer_buttons__3FPFz"};